import { apiGet } from '../../api'

export const get_facilitators = () => {
  return apiGet({
    endpoint: 'programs/get_facilitators'
  })
}
